import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import http from '../http';
import { userStore } from '../stores/UserStore';
import C from '../colors';

const WxLinkDialog = inject('snackbarStore')(observer(({ snackbarStore, open, onClose }) => {
  const [qrCode, setQrCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('pending');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    setStatus('pending');
    setError('');
    let timer;
    let cancelled = false;

    const poll = async (sessionId) => {
      if (cancelled) return;
      try {
        const response = await http.get(`/wechat/qr-sessions/${sessionId}`);
        const nextStatus = response.data.status;
        setStatus(nextStatus);
        if (nextStatus === 'confirmed') {
          const info = await http.get('/user/info');
          userStore.setWxOpenId(info.data.wxOpenId);
          snackbarStore.showSnackbar('绑定微信账号成功', 'success');
          onClose();
          return;
        }
        if (nextStatus === 'conflict' || nextStatus === 'failed') {
          setQrCode('');
          setError(response.data.errorCode === 'WECHAT_ALREADY_BOUND'
            ? '该微信已绑定其他摄影师账号'
            : '微信绑定失败，请重新生成二维码');
          return;
        }
        timer = setTimeout(() => poll(sessionId), 1000);
      } catch (requestError) {
        setQrCode('');
        setStatus('expired');
        setError('二维码已失效，请关闭后重新打开');
      }
    };

    http.post('/user/wechat/qr-sessions/bind').then(response => {
      if (response.status === 201) {
        setQrCode(response.data.imageData);
        setLoading(false);
        poll(response.data.sessionId);
      }
    }).catch(() => {
      setLoading(false);
      setError('二维码生成失败，请稍后重试');
    });
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [open]);

  if (!open) return null;

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 1300,
      background: 'rgba(26,20,23,.45)',
      backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: C.paper, borderRadius: 14,
        border: `1px solid ${C.hair}`,
        width: '100%', maxWidth: 360,
        boxShadow: '0 20px 50px -12px rgba(0,0,0,.25)',
        padding: '28px 28px 24px',
        textAlign: 'center',
      }}>
        <div style={{ fontFamily: C.mono, fontSize: 10, letterSpacing: 1.4, textTransform: 'uppercase', color: C.brand2, fontWeight: 600, marginBottom: 8 }}>
          WeChat
        </div>
        <h3 style={{ margin: '0 0 20px', fontFamily: C.serif, fontSize: 22, fontWeight: 400, color: C.ink }}>
          绑定微信账号
        </h3>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 240 }}>
          {loading && (
            <div style={{ fontSize: 14, color: C.ink3 }}>加载中…</div>
          )}
          {!loading && qrCode && (
            <img
              data-testid="wechat-bind-qr"
              src={`data:image/png;base64,${qrCode}`}
              alt="微信绑定二维码"
              style={{ width: 220, height: 220, borderRadius: 8 }}
            />
          )}
          {!loading && error && (
            <div data-testid="wechat-bind-error" style={{ fontSize: 13, color: '#c2412e', lineHeight: 1.6 }}>
              {error}
            </div>
          )}
        </div>

        <p style={{ margin: '12px 0 20px', fontSize: 12.5, color: C.ink3 }}>
          {status === 'scanned' ? '已扫码，正在确认账号' : '请使用微信扫描二维码完成绑定'}
        </p>

        <button onClick={onClose} style={{
          padding: '9px 24px', borderRadius: 9,
          border: `1px solid ${C.hair2}`, background: '#fff',
          color: C.ink2, fontFamily: C.sans, fontSize: 13, cursor: 'pointer',
        }}>
          关闭
        </button>
      </div>
    </div>
  );
}));

export default WxLinkDialog;
